import { ImageItemTranslator, RelationalActionTranslator, RelationalActionExtractor } from "../../../../../../documaker/infrastructure/document/ver2/translators";
import { IImageItemBean, ITypeDefinable } from "../../../../../../documaker/infrastructure/document/ver2/beans/items";
import { IDocumentImageSource, ImageSourceKinds } from "../../../../../../documaker/domain/document";
import { IItem, ImageItem } from "../../../../../../documaker/domain/document/items";
import { EditableFormatImageSource, EditableFormatTemporaryImageSource } from "../../../../../domain/editableFormat/sources";
import { Point, Rectangle, Size, } from "../../../../../../base/domain/drawing";

export class EditableDocumentImageItemTranslator extends ImageItemTranslator {
  constructor(_getToken: () => string) {
    super(_getToken);
  }

  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IImageItemBean;
    const result = new ImageItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.name = bean.name;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.imageSource = this.getImageSource(formatId, documentId, bean.imageStoragePlace, bean.imageGuid);
    result.originalImageSource = this.getImageSource(formatId, documentId, bean.originalImageStoragePlace, bean.originalImageGuid);
    result.drawLayerImageSource = this.getImageSource(formatId, documentId, bean.drawLayerImageStoragePlace, bean.drawLayerImageGuid);
    result.imageKind = bean.imageType;
    result.claioImageId = (bean.claioImageKey != null) ? bean.claioImageKey.toString() : null;
    result.shouldQuote = !!bean.isQuotable;
    result.supportedQuotable = !!bean.supportedQuotable;
    result.rotationAngle = bean.rotationAngle;
    result.imageDepartmentId = bean.imageDepartmentCode;
    result.externalImageId = bean.externalImageKey;
    const actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.scriptExecuteParameters = RelationalActionExtractor.extractScriptExecuteParameters(actions);
    return result;
  }

  getImageSource(formatId: number, documentId: number, storagePlace: number, imageGuid: string): IDocumentImageSource {
    return storagePlace === ImageSourceKinds.Cache
      ? new EditableFormatTemporaryImageSource(this._getToken, storagePlace, imageGuid)
      : new EditableFormatImageSource(this._getToken, formatId, documentId, storagePlace, imageGuid);
  }
}
